import React, {useState} from "react";
import {isEmpty} from "../../../_helpers/commonFunctions";
import {useDispatch, useSelector} from "react-redux";
import {Badge} from "react-bootstrap";
import {setDialNumber, setShowDial} from "../../../_reducers/crmSlice";
import {useTranslation} from "../../../hooks/useTranslation";

const Input = ({type, id, required, placeholder, label, unlabbled, charLimit,
                   onChange, onBlur, className, name, value, onKeyDown, disabled,
                   autoComplete, defaultValue, style, allowTelephoneDial, allowShowPassword,
                   allowSpecialCharacters,
               }) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const maxLength = charLimit ? charLimit : 250;
    const hasDialAbility = useSelector((state) => state.CRM.hasDialAbility);
    const [inputType, setInputType] = useState(type);

    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        if (type !== "password" && !allowSpecialCharacters) {
            e.target.value = inputValue.replace(/[$^*\[\]=+\\`~]/g, "");
        }
        if (onChange) onChange(e);
    }

    const handleOnBlur = (e) => {
        if (onBlur) onBlur(e);
    }

    const handleDialClick = () => {
        dispatch(setShowDial(true));
        dispatch(setDialNumber(value));
    }

    const toggleShowPassword = () => {
        if (inputType === "password") {
            setInputType("text");
        } else {
            setInputType("password");
        }
    }

    const showDialButton = hasDialAbility && allowTelephoneDial && String(value).length >= 3;

    return (
        <React.Fragment>
            <div className={className ? className : "w-100"} style={{position: allowShowPassword ? "relative" : ""}}>
                {!unlabbled && (
                    <label htmlFor={id}>
                        {label}
                        {required && <span className="text-danger"> *</span>}
                    </label>
                )}
                <input
                    maxLength={maxLength}
                    className="form-control"
                    type={inputType}
                    disabled={disabled}
                    name={name}
                    id={id}
                    value={value}
                    defaultValue={defaultValue}
                    onChange={handleInputChange}
                    onBlur={handleOnBlur}
                    autoComplete={autoComplete}
                    onKeyDown={onKeyDown}
                    style={style}
                    placeholder={isEmpty(placeholder) ? t('insertPlaceholders.add') + label : placeholder}
                    onWheel={(e) => e.target.blur()}
                />
                {showDialButton && (
                    <Badge bg={"primary"} style={{cursor: "pointer", position: "absolute", right: "18px", top: "32px"}} onClick={() => handleDialClick()}><i className="fa-solid fa-phone"></i></Badge>
                )}
                {(type === "password" && allowShowPassword) && (
                    <Badge bg={"primary"} style={{cursor: "pointer", position: "absolute", right: "10px", top: "32px"}} onClick={() => toggleShowPassword()}>
                        {inputType === "password" ? <i className="fa-solid fa-eye"></i> : <i className="fa-solid fa-eye-slash"></i>}
                    </Badge>
                )}
                {!isEmpty(value) && (String(value).length === maxLength) &&
                    <small className="text-info">Max length reached.</small>}
            </div>
        </React.Fragment>
    )
}

export default Input;
